import { useEffect, useRef } from 'react';

import { useFormikContext } from 'formik';

const AutoSavingForm = () => {
  const formik = useFormikContext();
  const lastSubmittedValues = useRef('');

  const valuesStr = JSON.stringify(formik.values);

  useEffect(() => {
    if (formik.isValid && !formik.isSubmitting && valuesStr !== lastSubmittedValues.current) {
      lastSubmittedValues.current = valuesStr;
      formik.submitForm();
    }
  }, [valuesStr, formik.isValid, formik.isSubmitting]);

  return null;
};

export default AutoSavingForm;

